import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'access-evo',
  version: '1.0.0',
  properties: [
    {
      key: 'environment',
      label: 'Environment',
      type: 'options',
      required: true,
      default: 'preproduction',
      options: [
        {
          value: 'preproduction',
          name: 'Pre-Production'
        },
        {
          value: 'staging',
          name: 'Staging'
        },
        {
          value: 'production',
          name: 'Production'
        },
      ],
    },
    {
      key: 'action',
      label: 'Action',
      type: 'options',
      required: true,
      default: 'getMember',
      options: [
        { value: 'getMember', name: 'Get Member' },
        { value: 'getAllMembers', name: 'Get All Members' },
        { value: 'getAllTags', name: 'Get All Tags' },
        { value: 'getAllGroups', name: 'Get All Groups' },
        { value: 'updateMember', name: 'Update Member' },
        { value: 'updateTag', name: 'Update Tag' },
        { value: 'updateGroup', name: 'Update Group' },
      ],
    },
    {
      key: 'testEmail',
      label: 'Test Email (Optional)',
      type: 'string',
      required: false,
      placeholder: 'user@example.com',
      description: 'Optional email to impersonate in Pre-Production. If empty, uses your logged-in email.',
      displayOptions: {
        show: {
          environment: ['preproduction']
        }
      }
    },
    {
      key: 'testAcid',
      label: 'Test Access ID (Optional)',
      type: 'string',
      required: false,
      placeholder: 'bda7b931-1980-49f6-b6d3-c509c2584c43',
      description: 'Optional Access user ID (acid) for test impersonation. If empty, uses configured default.',
      displayOptions: {
        show: {
          environment: ['preproduction']
        }
      }
    },
    {
      key: 'memberId',
      label: 'Member ID',
      type: 'string',
      required: false,
      placeholder: 'Enter member ID',
      description: 'Required for Get Member and Update Member actions',
      displayOptions: {
        show: {
          action: ['getMember', 'updateMember']
        }
      }
    },
    {
      key: 'memberData',
      label: 'Member Data',
      type: 'json',
      required: false,
      placeholder: '{\n  "firstName": "John",\n  "lastName": "Doe",\n  "jobTitle": "Developer",\n  "department": "Engineering",\n  "office": "London"\n}',
      description: 'JSON data for updating member. Fields: firstName, lastName, jobTitle, department, office',
      displayOptions: {
        show: {
          action: ['updateMember']
        }
      }
    },
    {
      key: 'tagId',
      label: 'Tag ID',
      type: 'string',
      required: false,
      placeholder: 'Enter tag ID',
      description: 'Required for Update Tag action',
      displayOptions: {
        show: {
          action: ['updateTag']
        }
      }
    },
    {
      key: 'userPropertyId',
      label: 'User Property ID',
      type: 'string',
      required: false,
      placeholder: 'Enter user property ID',
      description: 'Required for Update Tag action - the user property that contains the tag',
      displayOptions: {
        show: {
          action: ['updateTag']
        }
      }
    },
    {
      key: 'tagData',
      label: 'Tag Data',
      type: 'json',
      required: false,
      placeholder: '{\n  "name": "VIP"\n}',
      description: 'JSON data for updating tag. Fields: name',
      displayOptions: {
        show: {
          action: ['updateTag']
        }
      }
    },
    {
      key: 'groupId',
      label: 'Group ID',
      type: 'string',
      required: false,
      placeholder: 'Enter group ID',
      description: 'Required for Update Group action',
      displayOptions: {
        show: {
          action: ['updateGroup']
        }
      }
    },
    {
      key: 'groupData',
      label: 'Group Data',
      type: 'json',
      required: false,
      placeholder: '{\n  "name": "Premium Members",\n  "description": "High-value customers"\n}',
      description: 'JSON data for updating group. Fields: name, description',
      displayOptions: {
        show: {
          action: ['updateGroup']
        }
      }
    },
  ],
};

export default schema;
